import React, { useState, useEffect } from 'react';
import supabase from '../../helper/supabaseClient';
import { useUserProfile } from '../../helper/UserProfile';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { faArrowUpFromBracket } from '@fortawesome/free-solid-svg-icons';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import MobileRevalNav from '../mobile/MobileRevalNav';

function ReflectiveAccount() {

    const { profile } = useUserProfile();
    
    const [uploading, setUploading] = useState(false);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [ra, setRa] = useState([]);

    useEffect(() => {
        if (profile?.id) {
            fetchRa();
        }
    }, [profile]);

    //Select File and Upload
    const handleFileSelectAndUpload = async (e) => {
        const file = e.target.files?.[0];
        if (!file || !profile?.id) {
        setError('No file or user ID');
        return;
        }

        setUploading(true);
        setError("");
        setMessage("");

        const filePath = `${profile.id}/${file.name}`;

        const { error } = await supabase.storage
        .from('reflective-written-accounts')
        .upload(filePath, file, {
            cacheControl: '3600',
            upsert: true,
        });

        if (error ) {
        console.error(error);
        setError('Upload failed. Please try again.');
        setUploading(false);
        return;
        }

        const { dbError } = await supabase
        .from('revalidation_documents')
        .insert({
            user_id: profile.id,
            document_type: "Reflective",
            file_path: filePath,
            upload_date: new Date(),
            bucket: "reflective-written-accounts"
        });

        if (dbError) {
            console.error(dbError);
            setError("Metadata insert failed. File may be uploaded, but record not saved.")
        } else {
        setMessage('File uploaded successfully!');
        setError("");
        await fetchRa();
        }

        setUploading(false);
    };

    const handleButtonClick = () => {
        document.getElementById('fileInput').click();
    };

    //Delete
    const handleDelete = async (fileName) => {

        const { error } = await supabase
        .storage
        .from('reflective-written-accounts')
        .remove([`${profile.id}/${fileName}`]);

        const { dbError} = await supabase
        .from("revalidation_documents")
            .delete()
            .eq("file_path", [`${profile.id}/${fileName}`]);

        if (error) {
            setError("Failed to delete file");
        } else {
            setMessage("File deleted");
            await fetchRa();
        }
    };

    //Display list of files
    const fetchRa = async () => {
        const { data, error } = await supabase
        .storage
        .from('reflective-written-accounts')
        .list(profile.id);
    
        if (error) {
            console.error(error);
            setError("Error fetching reflective accounts")
        } else {
            setRa(data)
        }
    }


  return (
    <div>
        <div className="mob-only">
            <MobileRevalNav />
        </div> 
        <div className="dashboard-body">
            <h1>WRITTEN REFLECTIVE ACCOUNTS</h1>
            <p>You must have 5 written reflective accounts in the three year period since your registration was last renewed or you joined the register, and they must be recorded on the approved form.</p>

            <a href="/reflective-accounts-form.doc" download="Reflective Account Form.doc">
            <button className="reflective" style={{marginRight: "1rem"}}>
                <FontAwesomeIcon icon={faDownload} size="2xl"></FontAwesomeIcon>
                <br />
                Download Template
            </button></a>
            <input
            id="fileInput"
            type="file"
            accept=".pdf,.doc,.docx"
            onChange={handleFileSelectAndUpload}
            style={{display:"none"}}
            />
            <button className="reflective" onClick={handleButtonClick} disabled={uploading}>
                <FontAwesomeIcon icon={faArrowUpFromBracket} size="2xl"></FontAwesomeIcon>
                <br />
                Upload Form
            </button>
            <br></br>
            <br></br>
            {error && <p className="error-message">{error}</p>}
            {message && <p className="success">{message}</p>}
            <br></br>
            <h3>YOUR UPLOADED ACCOUNTS</h3>
            <p>NOTE: Please delete reflective accounts that falls outside of your revalidation window.</p>
            <p>{ra.length === 1 ? 'You currently have 1 reflective account on record.' : `You currently have ${ra.length} reflective accounts on record.`}</p>

            <table className="reval-log">
                <thead>
                    <tr>
                        <th>File Name</th>
                        <th>Upload Date</th>
                        <th style={{width:"1rem", backgroundColor:"#fff"}}></th>
                    </tr>
                </thead>
                <tbody>
                    {ra.map((entry, index) => (
                        <tr key={index}>
                            <td><a href={`https://dyuqmgoqgozadkxqnqqq.supabase.co/storage/v1/object/public/reflective-written-accounts/${profile.id}/${entry.name}`} target="_blank" style={{fontSize:"0.9rem"}}>{entry.name}</a></td>
                            <td>
                                {new Date(entry.created_at).toLocaleDateString('en-GB', {
                                    day: '2-digit',
                                    month: 'short',
                                    year: 'numeric',
                                })}
                            </td>
                            <td><FontAwesomeIcon icon={faTrashCan} style={{fontSize:"0.8rem"}} onClick={() => handleDelete(entry.name)}/>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        <div className="mob-bottom-buffer">
        </div>
        </div>
    </div>
  )
}

export default ReflectiveAccount